import styled from 'styled-components';

interface ICardAchiviementProps {
  photo: string;
  status: 'pending' | 'concluded';
}

export const Container = styled.div<ICardAchiviementProps>`
  padding: 1rem;
  height: 100%;
  transition: all 0.25s ease-in-out;
  background: ${props => props.theme.specific.asideModule};
  border-radius: ${props => props.theme.radius.primary};
  color: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.cards.border};
  overflow: hidden;
  opacity: 0.5;
  
  ${({ status }) =>
    status === 'concluded' && `filter: grayscale(0%);opacity: 1;`
  }

  ${({ status }) =>
    status === 'pending' && `filter: grayscale(100%);`
}

  &:hover {
    opacity: 0.9;

    > header {
      
      > main {

        &:before {
          width: 8rem;
          height: 8rem;
          ${({ status }) => status === 'pending' && `height: 7rem; width: 7rem;`}
        }
      }
    }
  }

  > header {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 180px;

    > main {
      position: relative;
      display: flex;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease-in-out;

      &:before {
        content: '';
        border-radius: 50%;
        width: 7rem;
        height: 7rem;
        background: ${props => props.theme.colors.pink};
        ${({ status }) => status === 'pending' && `filter: grayscale(100%);`}
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.4s ease-in-out;

        @keyframes pulseConquista {
          0% {
            transform: scale(0.9);
          }
          50% {
            transform: scale(1);
          }
          100% {
            transform: scale(0.9);
          }
        }
      }

      > img {
        width: 8rem;
        position: relative;
        ${({ status }) => status === 'pending' && `filter: grayscale(100%);`}
        ${({ status }) => status === 'concluded' && `animation: pulseConquista 1.5s infinite;`}
      }
    }
  }

  > div {
    border-radius: 8px 8px 0 0;
    overflow: hidden;

    > figure {
      height: 210px;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      background: url(${props => props.photo}) center center / cover no-repeat;

      ${({ status }) => status === 'pending' && `filter: grayscale(100%)`}
    }
  }

  > main {
    position: relative;
    padding: 28px 28px 22px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 91.6666666667%;
    padding: 28px;
    margin: 0 auto 1.25rem auto;
    border-radius: ${props => props.theme.radius.secondary};
    background: ${props => props.theme.cards.tertiary};
    border: 1px solid ${props => props.theme.cards.border};

    > button {
      background-color: ${props => props.theme.colors.primary};
      display: flex;
      height: 48px;
      border-radius: 10px;
      color: ${props => props.theme.colors.white};
      font-size: 0.875rem;
      font-weight: 700;
      text-align: center;
      line-height: 48px;
      cursor: pointer;
      text-decoration: none;
      transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
        border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
      align-items: center;
      justify-content: center;
      margin: 1rem 0 0 0;

      &:hover {
        background-color: ${props => props.theme.colors.info};
      }
    }

    > div > h2 {
      margin-top: 1rem;
      font-size: 1.25rem;
      font-weight: 700;
      line-height: 1.2em;
      color: ${props => props.theme.colors.white};
      text-align: center;
      margin-bottom: 1rem;

      /* TABLET */
      @media (max-width: 768px) {
      }
      /* MOBILE */
      @media (max-width: 480px) {
        min-height: unset;
      }
    }

    > div > h2 {
      margin-top: 1rem;
      font-size: 1.5rem;
      font-weight: 700;
      line-height: 1.2em;
    }

    > p {
      font-size: 0.875rem;
      line-height: 1.7142857143em;
      height: 77px;
      font-weight: 500;
      text-align: center;
      color: ${props => props.theme.colors.white};
    }

    > footer {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: center;
      padding: 1.5rem 0 0 0;

      > p {
        > span {
          font-size: 10px;
          font-weight: 700;
          text-transform: uppercase;
          margin-top: 1.6rem;
          color: ${props =>
            props.status === 'concluded'
              ? 'none'
              : props => props.theme.colors.white}40;
          background: ${props => props.theme.cards.primary}80;
          border: 1px solid ${props => props.theme.cards.border};
          padding: 4px 10px;
          border-radius: 25px;
          letter-spacing: 0.5px;
        }
      }
    }

    > img {
      position: absolute;
      z-index: -1;
      bottom: 0;
      right: -70px;
      width: 440px;
      filter: blur(50px);
    }
  }
`;

export const Description = styled.p`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  color: ${props => props.theme.colors.muted};
`;

interface IBadgeProps {
  status: 'pending' | 'concluded';
}

export const Badge = styled.div<IBadgeProps>`
  position: absolute;
  display: flex;
  flex-direction: row;
  right: -7px;
  top: 10px;
  background: #9e90fd;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 11px;
  color: #fff;

  > img {
    width: 16px;
    margin-right: 4px;
  }

  > strong {
    margin-right: 2px;
  }
`;


export const Points = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  > strong {
    font-size: 3rem;
    font-weight: 700;
    color: ${props => props.theme.colors.white};
  }
`;